import type { Player } from "../../engine/player";
import type { CollectableItem } from "../../engine/collectableItem";
import { isToggleable } from "../../engine/interfaces";
import { Strings } from "../../engine/strings";
import { getPickupIconFilenameByKey } from "../pickupIconMap";

export interface InventoryRow {
	itemKey: string;
	displayName: string;
	count: number;
	isUsable: boolean;
	hotkeyLabel: string | null;
	iconFilename: string | null;
	useLabel: string;
	stateLabel: string | null;
}

export interface GoldDelta {
	currentGold: number;
	deltaSinceLastTurn: number;
}

/** Pure — engine state in, plain data out. Gold-delta fade timing is renderer-local. */
export class InventoryViewModel {
	/** Insertion order, matching Inventory's Map iteration. Gold is rendered separately. */
	computeRows(player: Player): InventoryRow[] {
		const rows: InventoryRow[] = [];
		for (const item of player.inventory.getAllItems()) {
			rows.push(this.buildRow(item));
		}
		return rows;
	}

	private buildRow(item: CollectableItem): InventoryRow {
		const itemKey = (item.constructor as any).key as string;
		const toggleable = isToggleable(item);
		return {
			itemKey,
			displayName: item.getName(),
			count: item.count,
			isUsable: item.isUsable(),
			hotkeyLabel: item.getHotkeyLabel(),
			iconFilename: getPickupIconFilenameByKey(itemKey),
			useLabel: toggleable ? item.getUseButtonLabel() : (Strings.get("ui_itemUse") ?? "USE"),
			stateLabel: toggleable ? item.getStateLabel() : null,
		};
	}

	computeGoldDelta(player: Player, previousGold: number): GoldDelta {
		return {
			currentGold: player.gold,
			deltaSinceLastTurn: player.gold - previousGold,
		};
	}
}
